import { APIDriver } from '@cmd/ui-utilities';
export var LeadsDataSource;
(function (LeadsDataSource) {
    LeadsDataSource["ATKBB"] = "atkbb";
    LeadsDataSource["DDC"] = "ddc";
    LeadsDataSource["VIN_SOLUTIONS"] = "vin-solutions";
    LeadsDataSource["VIN_CRM"] = "vin-crm";
    LeadsDataSource["ICO"] = "kbbico";
})(LeadsDataSource || (LeadsDataSource = {}));
export var LeadsResource;
(function (LeadsResource) {
    LeadsResource["BY_LEAD"] = "by-lead";
    LeadsResource["DATA_BY_SOURCE"] = "data-by-source";
    LeadsResource["LEADS_BY_AGE"] = "leads-by-age";
    LeadsResource["TOP_IN_STOCK"] = "top-in-stock";
    LeadsResource["TOP_MODELS"] = "top-models";
    LeadsResource["TOP_PRODUCTS"] = "top-products";
    LeadsResource["TOP_SOURCES"] = "top-sources";
    LeadsResource["TOP_TYPES"] = "top-types";
    LeadsResource["TOP_VEHICLES"] = "top-vehicles";
    LeadsResource["LEADS_BY_TRADE_IN"] = "leads-by-trade-in";
})(LeadsResource || (LeadsResource = {}));
const RESOURCES = [
    LeadsResource.BY_LEAD,
    LeadsResource.DATA_BY_SOURCE,
    LeadsResource.LEADS_BY_AGE,
    LeadsResource.TOP_IN_STOCK,
    LeadsResource.TOP_MODELS,
    LeadsResource.TOP_PRODUCTS,
    LeadsResource.TOP_SOURCES,
    LeadsResource.TOP_TYPES,
    LeadsResource.TOP_VEHICLES,
    LeadsResource.LEADS_BY_TRADE_IN,
];
const getLeadsResources = (source, endpoints) => endpoints.map((endpoint) => `${source}/${endpoint}`);
const leadsApiConfig = {
    baseUrl: '/api/leads/',
    resources: [
        ...getLeadsResources(LeadsDataSource.ATKBB, RESOURCES), // May change based on actual endpoints
        ...getLeadsResources(LeadsDataSource.ICO, RESOURCES),
        ...getLeadsResources(LeadsDataSource.DDC, RESOURCES),
        ...getLeadsResources(LeadsDataSource.VIN_SOLUTIONS, RESOURCES),
        ...getLeadsResources(LeadsDataSource.VIN_CRM, RESOURCES),
    ],
};
const leadsApi = new APIDriver(leadsApiConfig);
export default leadsApi;
